import { useEffect, useState } from "react";
import api from "../../services/api";
import { useAuth } from "../../hooks/auth";
import refreshToken from "../../utils/refreshToken";

export type PropertyListCityOption = {
  city: string;
  uf?: string;
};

export type PropertyListConsultantOption = {
  id: number;
  first_name: string;
};

export function usePropertyListFilterOptions(includeConsultant: boolean) {
  const { access_token, dateToExpires, user } = useAuth();
  const [cities, setCities] = useState<PropertyListCityOption[]>([]);
  const [consultants, setConsultants] = useState<
    PropertyListConsultantOption[]
  >([]);

  useEffect(() => {
    if (!user) return undefined;

    let cancelled = false;

    async function loadOptions() {
      try {
        const token = await refreshToken(dateToExpires, access_token);
        api.defaults.headers.authorization = `Bearer ${token ?? access_token}`;
        const response = await api.get("/api/adm/addresses/cities/get");
        const raw = response.data?.data;
        if (!cancelled) {
          setCities(Array.isArray(raw) ? raw : []);
        }
      } catch {
        if (!cancelled) setCities([]);
      }

      if (!includeConsultant) {
        if (!cancelled) setConsultants([]);
        return;
      }

      try {
        const token = await refreshToken(dateToExpires, access_token);
        api.defaults.headers.authorization = `Bearer ${token ?? access_token}`;
        const response = await api.get("/api/adm/users", {
          params: { role: "consultant" },
        });
        const raw = response.data?.data?.consultants;
        if (!cancelled) {
          setConsultants(Array.isArray(raw) ? raw : []);
        }
      } catch {
        if (!cancelled) setConsultants([]);
      }
    }

    loadOptions();
    return () => {
      cancelled = true;
    };
  }, [user, access_token, dateToExpires, includeConsultant]);

  return { cities, consultants };
}
